module.exports = __webpack_public_path__ + "img/Live.78bc6a2e.png";